import { signal, WritableSignal } from "@angular/core";

import { IBreadcrumbItemModel } from "@app/shared";

export class SearchModel implements IBreadcrumbItemModel {
    public id: string;
    public name: WritableSignal<string>;
    public isChecked: WritableSignal<boolean>;
    public select: (isSelected: boolean) => void;

    constructor() {
        this.name = signal<string>(null);
        this.isChecked = signal<boolean>(false);
    }
}